module.exports = __webpack_public_path__ + "img/marker_odp_default-0.68e7baef.png";